<template>
  <div>
    <template>
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white black--text " @click="close"> close </v-btn>
        </v-toolbar>
      </v-card>
    </template>
    <v-card>
      <v-container class="fixWidth">
        <v-form ref="formVal" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="mt-2">
              <v-text-field
                v-model="getSchema.title"
                required
                :rules="generalRules"
              >
                <template v-slot:label>
                  Link Title<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="mt-2">
              <v-text-field
                v-model="getSchema.url"
                required
                :rules="generalRules.concat(urlRules)"
              >
                <template v-slot:label>
                  Link Url<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            color="primary  white--text"
            @click.stop.prevent="validateBefore()"
            >{{ buttonTitle }}</v-btn
          >

          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validationRules from "../../mixins/validationRules";
export default {
  components: {},
  mixins: [validationRules],
  props: ["dialogStatus", "editedData", "indexEdited"],
  data: () => ({
    loading: false,
    dialog: false,
    progressShow: false,
    valid: false,
    generalRules: [(v) => !!v || "This field is required"],
  }),
  created() {},
  mounted() {},
  watch: {
    dialogStatus(val) {
      this.dialog = val;
      this.$store.commit("SET_PORTAL_IMPORTANT_LINK_SCHEMA", this.editedData);
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getSchema() {
      return this.$store.getters.getPortalImportantLinkSchema;
    },
    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Create New Important Link"
        : "Edit New Important Link";
    },
    getLoaderStatus() {
      return this.$store.getters.getLoaderStatus;
    },
  },
  methods: {
    validateBefore() {
      let valid = this.$refs.formVal.validate();
      if (valid) {
        this.validationForm();
      }
    },
    save() {
      let self = this;
      // this.progressShow = true;
      let item = this.getSchema;
      this.$store
        .dispatch("savePortalImportantLinkData", item)
        .then(function (data) {
          // self.progressShow = false;
          try {
            self.close();
            self.$emit("callReget", true);
            // self.$store.dispatch("callPortalImportantLinkData");
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function () {});
    },
    edit() {
      let self = this;
      let item = this.getSchema;
      this.$store
        .dispatch("editPortalImportantLinkData", item)
        .then(function (data) {
          self.close();
          self.$emit("update:loadData", true);
          self.$emit("callReget", false);
          // self.$store.dispatch("callPortalImportantLinkData");
        })
        .catch(function (error) {
         //  console.log(error);
        });
      this.$emit("saveText", -1);
    },

    close() {
      this.$store.commit("SET_LOADER", false);
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },

    validationForm() {
      return this.indexEdited === -1 ? this.save() : this.edit();
    },
    clear() {
      this.getSchema.title = "";
      this.getSchema.url = "";
      this.$refs.formVal.reset();
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.fixWidth {
  width: auto;
}
</style>
